import axiosClient from "../axiosClient"

const login = (data) => {
    return axiosClient.post("login", data)
}

export {
    login
}